import { isDefined } from "@clipboard-health/util-ts";
import { useFormContext } from "react-hook-form";

import { SingleSelectQuestion } from "../components/SingleSelectQuestion";
import { SurveyStepLayout } from "../components/SurveyStepLayout";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";
import {
  oasisAssessmentRangeLabels,
  oasisAssessmentRangeValues,
} from "../lib/screeningSurveyTypes";

const options = oasisAssessmentRangeValues.map((value) => ({
  value,
  label: oasisAssessmentRangeLabels[value],
}));

interface OasisAssessmentsStepProps {
  onContinue: () => void;
  onBack: () => void;
  currentStep: number;
  totalSteps: number;
}

export function OasisAssessmentsStep(props: OasisAssessmentsStepProps) {
  const { onContinue, onBack, currentStep, totalSteps } = props;
  const { watch, setValue } = useFormContext<ScreeningSurveyFormData>();
  const value = watch("oasisAssessments");

  return (
    <SurveyStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title="How many OASIS assessments have you done?"
      continueDisabled={!isDefined(value)}
      onBack={onBack}
      onContinue={onContinue}
    >
      <SingleSelectQuestion
        options={options}
        value={value}
        onChange={(v) => {
          setValue("oasisAssessments", v);
        }}
      />
    </SurveyStepLayout>
  );
}
